import { Injectable } from '@angular/core';
import { all, create } from 'mathjs';
import { toMathJsSyntax } from '../helpers/js-expression';

const math = create(all, {
  number: 'number',  // Use standard number type (not BigNumber)
  precision: 14,      // Optional: you can set precision here
});

@Injectable({
  providedIn: 'root',
})
export class ExpressionEvaluatorService {
  /**
   * mathjs, accepting the JavaScript-style expressions mobile evaluates (`&&`, `||`, `===`, `!`, `Number(...)`,
   * `Math.*`; see toMathJsSyntax), so a form calculation behaves the same on both.
   */
  evaluateExpression(expression: string, variables: Record<string, any>): number {
    try {
      const compiled = math.parse(toMathJsSyntax(expression)).compile();
      const result = compiled.evaluate({ Math, Number: (value: unknown) => Number(value), ...variables });
      return Number(result);
    } catch (err) {
      throw err;
    }
  }
}
